import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import ContactData from "./ContactData";
import FormDetails from "./FormDetails";

const ContactUs = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const contactTabItems = [
    {
      label: "Contact Details",
      key: "contactDetails",
      children: (
        <div>
          <ContactData />
        </div>
      ),
    },
    {
      label: "Form Details",
      key: "formDetails",
      children: (
        <div>
          <FormDetails />
        </div>
      ),
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("thirdChildActiveTab") || "contactDetails"}
      items={contactTabItems}
      onChange={(activeKey) => {
        navigate(
          `${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${query.get("subActiveTab")}&thirdChildActiveTab=${activeKey}`
        );
      }}
    ></Tabs>
  );
};

export default ContactUs;
